import React from 'react';
import Tooltip from "@material-ui/core/Tooltip";


export default function WhatsappContact() {
    return (
        <div className="whatsappCover">
        <Tooltip
          title="Connect with me on whatsapp"
          interactive
          arrow
          placement="top"
        >
          <a href="https://wa.me/918791387332?text=Hi%20Kushal,%20I%27m%20interested%20by%20your%20website%20and%20want%20to%20connect%20with%20you." target="_blank">
            <img
              src="images/vectors/group-7.svg"
              alt="whatsapp-icon"
              className="Group-7"
            />
          </a>
        </Tooltip>
      </div>
    )
}
